var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classNames from 'classnames';
import moment from 'moment-timezone';
import React, { useRef } from 'react';
import { EditIcon } from '../../Components/Icons';
import { FormattedInput } from '../../Components/FormFields/FormattedInput';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import { standardName } from '../../Shared/StringUtilities';
import { primaryBlue } from '../../Styles/Colours';
import styles from './EditMedicationInfoLine.module.css';
import { Fields } from './EditMedicationTitle';
import { useField } from '../../Components/useForm/useField';
export function EditMedicationInfoLine(props) {
    var _a, _b, _c;
    var dateRef = useRef(null);
    var editIconClass = classNames(styles.editIcon, (_a = {},
        _a[styles.focused] = props.inputEditMode,
        _a));
    var performedOnDateField = useField({ form: props.form, field: 'performedOn' });
    var providerInformation = 'No Provider';
    if (props.provider) {
        var providerName = standardName({
            title: props.provider.title ? props.provider.title.name : '',
            givenNames: props.provider.givenName,
            familyName: props.provider.familyName
        });
        providerInformation = "" + providerName;
    }
    var dateInputClassNames = classNames(props.readOnly ? styles.dateInputReadOnly : styles.dateInput, (_b = {},
        _b[styles.inputFocused] = props.inputEditMode,
        _b[styles.inputError] = !!performedOnDateField.error,
        _b));
    var datePlaceHolderTextClasses = classNames(styles.datePlaceHolderText, (_c = {},
        _c[styles.clickable] = !props.readOnly,
        _c));
    var prettyDateFormat = moment(performedOnDateField.value, [
        ValidDateFormats.IsoFormat,
        ValidDateFormats.Edit
    ]).format(ValidDateFormats.Display);
    var performedOnControls = props.form.registerInputWithErrorText('performedOn');
    return (React.createElement("div", { className: styles.infoLine },
        React.createElement("div", { className: styles.timeAndProviderInformation },
            React.createElement("span", { className: styles.infoText }, "Recorded: "),
            props.inputEditMode && !props.readOnly ? (React.createElement(FormattedInput, __assign({}, performedOnControls, { className: dateInputClassNames, containerClass: styles.dateContainer, readOnly: props.readOnly, onFocus: props.onFieldFocus(Fields.Date), onBlur: props.onFieldBlur, placeholder: 'DD/MM/YYYY', formatOptions: {
                    date: true,
                    delimiter: '/',
                    datePattern: ['d', 'm', 'Y']
                }, testId: 'performed-on', autoFocus: true, inputRef: dateRef, errorText: performedOnControls.touched ? performedOnControls.errorText : '' }))) : (React.createElement("span", { onClick: props.onFieldClick(Fields.Date), className: datePlaceHolderTextClasses }, prettyDateFormat)),
            React.createElement("span", { className: styles.infoText },
                "by ",
                providerInformation),
            !props.readOnly && (React.createElement("span", { className: editIconClass, onClick: props.onEditButtonClick, "data-test-id": 'edit-recorded-time' },
                React.createElement(EditIcon, { size: '18', color: primaryBlue, noPadding: true }),
                "Edit")))));
}
